export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10404.7e0f2ec2.jpg";